<template>
  <span :style="cssProps">
      <v-row align="center" no-gutters class="res-select-update-header pa-0 my-3 ma-0">
        <v-col cols="3">
          <v-checkbox dense
                      :value="allCheckSelected"
                      :color="checkboxColor"
                      hide-details
                      @change="selectAll"
                      class="mx-2 ma-0 pl-3">
            <template v-slot:label>
              <span class="px-5x nowrap calc-row">
                <v-icon v-if="showCalculator" :color="bulkCalculatorColor" @click.stop="openBulkCalculator">mdi-calculator</v-icon>
                {{showCalculator ? 'Bulk Calculator (Select one or more checkboxes)' : 'Select All'}}
              </span>
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="9">
          <res-button height='30px'
                      :dark="true"
                      :depressed="true"
                      :icon="true"
                      v-if="!hideUpdateBtn"
                      iconText="mdi-autorenew"
                      iconColor="resGrey base"
                      roundness="15px"
                      buttonText='UPDATE VALUES'
                      backgroundColor='var(--v-resGrey-lighten3)'
                      buttonTextColor='var(--v-resGrey-base)'
                      buttonClass='mr-4'></res-button>
        </v-col>
      </v-row>
  </span>
</template>

<script>
  import ResButton from '@/components/base/ResButton.vue';

  export default {
    name: 'ResSelectUpdateHeader',
    components: {
      ResButton
    },
    props: {
      label: {
        type: String,
        default: 'Group'
      },
      minWidth: {
        type: Number,
        default: 0
      },
      allCheckSelected: {
        type: Boolean,
        default: false
      },
      anyCheckSelected: {
        type: Boolean,
        default: false
      },
      hideUpdateBtn: {
        type: Boolean,
        default: false
      },
      showCalculator: {
        type: Boolean,
        default: false
      }
    },
    data: function () {
      return {}
    },
    computed: {
      cssProps() {
        return {
          '--min-width-stretch': this.minWidth + 'px'
        }
      },
      checkboxColor() {
        var checked = this.anyCheckSelected || this.allCheckSelected;
        return checked ? 'resBlue darken-1' : 'resGrey darken-1'
      },
      bulkCalculatorColor() {
        var checked = this.anyCheckSelected || this.allCheckSelected;
        return checked ? 'var(--v-resBlue-darken1)' : 'var(--v-resGrey-darken1)'
      }
    },
    methods: {
      selectAll: function () {
        this.$emit("selectionChanged", this.allCheckSelected)
      },
      openBulkCalculator: function () {
        if (this.anyCheckSelected) {
          this.$emit('bulkCalculatorOpened');
        }
      },
      toggleCheckboxColor: function () {
        if (this.anyCheckSelected) {
          setTimeout(() => {
            this.$el.querySelector('i.v-icon').classList.add('resBlue--text');
            this.$el.querySelector('i.v-icon').classList.add('text--darken-1');
          })
        }
        else {
          setTimeout(() => {
            this.$el.querySelector('i.v-icon').classList.remove('resBlue--text');
            this.$el.querySelector('i.v-icon').classList.remove('text--darken-1');
          })
        }
      }
    },
    watch: {
      anyCheckSelected() {
        this.toggleCheckboxColor();
      },
      allCheckSelected() {
        this.toggleCheckboxColor();
      }
    }
  }
</script>

<style scoped lang="scss">
  .res-select-update-header {
    background-color: white;
    height: 40px !important;
    border: 1px solid var(--v-resGrey-lighten3) !important;
    min-width: var(--min-width-stretch);
  }
  .calc-row {
    font-family: Roboto, sans-serif;
    font-size: 12px !important;
    font-weight: 700;
    letter-spacing: 0.1px;
  }

    .res-select-update-header > span {
      line-height: 40px;
    }
</style>
